// Import the functions you need from the SDKs you need
import {initializeApp} from "firebase/app";
import {getAnalytics} from "firebase/analytics";
import {getAuth} from 'firebase/auth'
import {getFirestore} from 'firebase/firestore'
import {getStorage} from 'firebase/storage'
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
// bitnovaworld@gmail.com
const firebaseConfig = {
    apiKey: "AIzaSyBpNsU1Io-W2echOdlZUyg_vFOUDg7PL_k",
    authDomain: "bitnovawolrd.firebaseapp.com",
    projectId: "bitnovawolrd",
    storageBucket: "bitnovawolrd.firebasestorage.app",
    messagingSenderId: "646233476455",
    appId: "1:646233476455:web:e777ae87a6a189d399b3c2",
    measurementId: "G-FP0VP7R6BL"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);

export const auth = getAuth(app)
export const fire = getFirestore(app)
export const storage = getStorage(app)